import {
  GSButton,
  GSInfoGroup,
} from "golfstatus_react_components";
import {
  faClock,
  faCheckCircle,
  faPen,
} from "@fortawesome/free-solid-svg-icons";
import { getV3DateTime } from "../../../helpers/Dates";
import { getMessageCountLines } from "../../../forms/MessageForms";
import "./tournament-message-card.scss";

const TournamentMessageCard = (props) => {
  const {
    subject,
    channel,
    scheduledFor,
    sentAt,
    status,
    sender,
    disabled,
    style,
  } = props;

  const isDisabled = disabled === true;

  const displayStatus = status;
  const isLegacySentMessage = displayStatus === "sent" && !channel;

  const getStatusColor = () => {
    switch (displayStatus) {
      case "scheduled":
        return "black";
      case "sent":
        return "green";
      case "draft":
        return "light-grey";
      default:
        return "";
    }
  };

  const getStatusIcon = () => {
    switch (displayStatus) {
      case "scheduled":
        return faClock;
      case "sent":
        return faCheckCircle;
      case "draft":
        return faPen;
      default:
        return null;
    }
  };

  const getStatusBadge = () => {
    if (!displayStatus) return null;
    return (
      <GSButton
        title={displayStatus}
        buttonIcon={getStatusIcon()}
        type={`secondary status pill ${getStatusColor()}`}
        isDisabled={isDisabled}
      />
    );
  };

  const getTypeLabel = () => {
    if (channel === "email") return "Email";
    return "App Notification";
  };

  const getDateDisplay = () => {
    if (displayStatus === "draft") return "";
    const date = sentAt || scheduledFor;
    if (!date) return "";
    return getV3DateTime(date);
  };

  const getSenderPrefix = () => {
    switch (displayStatus) {
      case "sent":
        return "Sent";
      case "scheduled":
        return "Scheduled";
      default:
        return "Created";
    }
  };

  const getSenderDisplay = () => {
    if (!sender?.firstName && !sender?.lastName) return "";
    return `${getSenderPrefix()} by ${sender?.firstName ??
      ""} ${sender?.lastName ?? ""}`.trim();
  };

  const infoSection = {
    sectionItems: [
      { type: "primary full-width", value: subject || "No Subject" },
      ...(isLegacySentMessage
        ? []
        : [
            { type: "secondary full-width", value: getTypeLabel() },
            ...getMessageCountLines(props).map((value) => ({
              type: "secondary full-width",
              value,
            })),
          ]),
    ],
  };

  const dateSectionItems = [];
  const dateDisplay = getDateDisplay();
  if (dateDisplay) {
    dateSectionItems.push({
      type: "secondary full-width",
      value: dateDisplay,
    });
  }
  const senderDisplay = getSenderDisplay();
  if (senderDisplay) {
    dateSectionItems.push({
      type: "secondary full-width",
      value: senderDisplay,
    });
  }

  const dateSection = {
    sectionItems: dateSectionItems,
  };

  const badgeSection = {
    sectionItems: [
      {
        type: "primary no-wrap full-width",
        value: getStatusBadge(),
      },
    ],
  };

  const dataGroups = [
    {
      fit: "stretch",
      sections: [infoSection, dateSection, badgeSection],
    },
  ];

  const groupStyle = {
    whiteSpace: "normal",
    ...(isDisabled ? { opacity: 0.5 } : null),
    ...style,
  };

  return (
    <GSInfoGroup
      listType="mobile-vertical"
      dataGroups={dataGroups}
      style={groupStyle}
      type={isDisabled ? "tournament-message-card-disabled" : undefined}
    />
  );
};

export default TournamentMessageCard;
